export const HOME_ROUTE_TARGETS = {
  loggedOutHome: '/home',
};
